import QRCodeStyling from "qr-code-styling";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export const OpenOnMobileQrCode = () => {
  const [qrCodeStyling] = useState<QRCodeStyling>(
    new QRCodeStyling({
      // width: 250,
      // height: 250,
      type: "svg",
      data: window.location.href,
      margin: 0,
      qrOptions: { typeNumber: "0", mode: "Byte", errorCorrectionLevel: "Q" },
      imageOptions: { hideBackgroundDots: true, imageSize: 0.7, margin: 5 },
      dotsOptions: {
        type: "extra-rounded",
        color: "#6a1a4c",
        gradient: {
          type: "radial",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#14282b" },
            { offset: 1, color: "#14282b" },
          ],
        },
      },
      backgroundOptions: { color: "transparent" },
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#14282b",
          color2: "#14282b",
          rotation: "0",
        },
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        color: "#14282b",
        gradient: {
          type: "radial",
          rotation: 0,
          colorStops: [
            { offset: 0, color: "#14282b" },
            { offset: 1, color: "#14282b" },
          ],
        },
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#14282b",
          color2: "#14282b",
          rotation: "0",
        },
      },
      cornersDotOptions: { type: "", color: "#14282b" },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#ffffff",
          color2: "#ffffff",
          rotation: "0",
        },
      },
    } as any)
  );

  const [qrCode, setQrCode] = useState<any | null>();

  useEffect(() => {
    qrCodeStyling.getRawData("svg").then((dataUrl) => {
      if (dataUrl) {
        // @ts-ignore
        setQrCode(URL.createObjectURL(dataUrl));
      }
    });
  }, []);

  return qrCode && <img src={qrCode} className={"object-fit"} />;
};

export const OpenOnMobileModal = () => {
  const location = useLocation();
  const [isHideOpenOnMobile, setIsHideOpenOnMobile] = useState(false);
  useEffect(() => {
    const w = window as any;
    const isOpened = w?.AddToHomeScreenInstance?.closeEventListener;
    const isAllowedToOpen = w?.AddToHomeScreenInstance?.allowUserToCloseModal;
    if (
      !location.pathname.includes("reset-password") &&
      !location.pathname.includes("preview-cards") &&
      !isOpened &&
      isAllowedToOpen
    ) {
      w.AddToHomeScreenInstance.allowUserToCloseModal = false;
      w.AddToHomeScreenInstance.show();
      setTimeout(() => {
        w.AddToHomeScreenInstance.allowUserToCloseModal = true;
        w.AddToHomeScreenInstance._registerCloseListener();
      }, 100);
    }

    if (
      location.pathname.includes("reset-password") ||
      location.pathname.includes("preview-cards")
    ) {
      setIsHideOpenOnMobile(true);
    }
  }, [location.pathname]);

  return (
    <div
      className={`hidden ${
        isHideOpenOnMobile ? "" : "lg:flex"
      } w-full h-screen bg-primary justify-center items-center fixed z-50`}
    >
      <div
        className={"h-[600px] w-[400px] bg-light p-20  rounded-2xl text-center"}
      >
        <OpenOnMobileQrCode />
        <p className={"mt-10"}>
          Open the app on your mobile device by scanning this QR code.
        </p>
      </div>
    </div>
  );
};
